/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Elbow_FlexionInputs */

const en_us2_catalog_movement_elbow_flexion = /** @type {(inputs: Catalog_Movement_Elbow_FlexionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`curl`)
};

const pt_br2_catalog_movement_elbow_flexion = /** @type {(inputs: Catalog_Movement_Elbow_FlexionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rosca`)
};

const es_419_catalog_movement_elbow_flexion = /** @type {(inputs: Catalog_Movement_Elbow_FlexionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`curl`)
};

const pt_pt2_catalog_movement_elbow_flexion = /** @type {(inputs: Catalog_Movement_Elbow_FlexionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`curl`)
};

const fr_fr2_catalog_movement_elbow_flexion = /** @type {(inputs: Catalog_Movement_Elbow_FlexionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`curl`)
};

const de_de2_catalog_movement_elbow_flexion = /** @type {(inputs: Catalog_Movement_Elbow_FlexionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curls`)
};

const it_it2_catalog_movement_elbow_flexion = /** @type {(inputs: Catalog_Movement_Elbow_FlexionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`curl`)
};

/**
* | output |
* | --- |
* | "curl" |
*
* @param {Catalog_Movement_Elbow_FlexionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_elbow_flexion = /** @type {((inputs?: Catalog_Movement_Elbow_FlexionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Elbow_FlexionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_elbow_flexion(inputs)
	if (locale === "es-419") return es_419_catalog_movement_elbow_flexion(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_elbow_flexion(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_elbow_flexion(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_elbow_flexion(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_elbow_flexion(inputs)
	return en_us2_catalog_movement_elbow_flexion(inputs)
});
export { catalog_movement_elbow_flexion as "catalog.movement.elbow_flexion" }